import { SvgIconProps } from "@mui/material";

// A large pane (3/4 height) above a small pane (1/4 height), single column.
export const SplitRowsQuarterIcon = (props: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
    {...props}
  >
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <rect x="2" y="2" width="20" height="13.5" rx="1.5" />
    <rect x="2" y="17.5" width="20" height="4.5" rx="1.5" />
  </svg>
);
